import {Box, IconButton, useTheme} from '@mui/material';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@mui/icons-material';
import {LightTooltip} from '@ui/LightTooltip/LightTooltip';
import {useTranslation} from 'react-i18next';

type TablePaginationActionsProps = {
    page: number;
    rowsPerPage: number;
    count: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
};

export const TablePaginationActions = (props: TablePaginationActionsProps) => {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    const {t} = useTranslation('tables');

    return (
        <Box
            component='div'
            sx={{flexShrink: 0, ml: 2.5}}
        >
            <LightTooltip title={t('previousPage')}>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0}
                    aria-label={t('previousPage')}
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
            </LightTooltip>

            <LightTooltip title={t('nextPage')}>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label={t('nextPage')}
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
            </LightTooltip>
        </Box>
    );
};
